import React from 'react';
import { trim } from 'lodash';
import PropTypes from 'prop-types';
import ShowMoreText from 'react-show-more-text';

import { connect } from 'react-redux';
import SvgComponent from '../SvgComponent';
import { STATIC_ROOT } from '../../constants';
import { toDate } from '../../utils/dateUtils';
import { getInstertitielCouponUrl } from '../../utils';
import ButtonComponent from '../button/ButtonComponent';
import { showModal } from '../../services/modal/actions';
import { MOMENTJS_DATE_FORMAT } from '../../constants/moment';
import LinkButtonComponent from '../button/LinkButtonComponent';
import { MODAL_TYPE_LOGIN } from '../../services/modal/constants';
import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';

import './CouponComponent.scss';

class CouponComponent extends React.Component {
    showLoginModal = () => {
        const { showModal } = this.props;

        showModal(MODAL_TYPE_LOGIN);
    };

    createCouponTitle = () => {
        const { coupon, partnerName, i18nCoupon } = this.props;
        if (coupon.reductionType) {
            let titre = '';
            if (coupon.value) {
                titre = `${i18nCoupon.DISCOUNTOF} ${coupon.valueFormat}`;
            } else {
                titre = `${i18nCoupon.DISCOUNT} ${partnerName}`;
            }
            if (coupon.deliveryType) {
                titre += ` ${i18nCoupon.PLUS_FREEDELIVERY}`;
            } else if (coupon.gifType) {
                titre += ` ${i18nCoupon.PLUS_GIFT}`;
            }
            return titre;
        } else if (coupon.deliveryType) {
            return `${i18nCoupon.FREEDELIVERY} ${partnerName}`;
        } else if (coupon.gifType) {
            return `${i18nCoupon.GIFT}z ${partnerName}`;
        } else {
            return `${i18nCoupon.ADVANTAGE} ${partnerName}`;
        }
    };

    render() {
        const { coupon, i18nCoupon, isAuthenticated, i18n, partnerId } = this.props;
        // on fait un trim car il se peut que qu'il est juste un espace dans le code et donc ce n'est pas un code promo mais un bon plan
        const code = trim(coupon.code);
        return (
            <div
                className={`fm-coupon grid has-gutter flex-center-alt ${
                    isAuthenticated ? 'co' : ''
                }`}
                id={coupon.id}>
                <div className="fm-coupon-svg hidden-mobonly">
                    <SvgComponent src={`${STATIC_ROOT}/code-promo.svg`} width="29" height="35" />
                </div>
                <div className="fm-coupon-offre">
                    <div className="title bold">{this.createCouponTitle()}</div>
                    <div className="descoffre">
                        <ShowMoreText
                            lines={2}
                            more={i18n.common.ensavoirplus}
                            less={i18n.common.cacher}
                            anchorClass="fakelink">
                            {convertHtmlToReactDomWithParams(coupon.description)}
                        </ShowMoreText>
                        {coupon.cumulativeWithCashback && (
                            <div className="cumulative">{i18nCoupon.CUMULATIVE}</div>
                        )}
                    </div>
                </div>
                <div className="one-sixth fm-coupon-bt">
                    {isAuthenticated ? (
                        <LinkButtonComponent
                            color={code ? 'main' : 'main'}
                            to={getInstertitielCouponUrl({
                                idPartenaire: partnerId,
                                idCoupon: coupon.id
                            })}
                            text={code ? code : i18n.feature.bonplan.button.TEXT}
                            title={code ? code : i18n.feature.bonplan.button.TEXT}
                            target="_blank"
                        />
                    ) : (
                        <ButtonComponent
                            color="main"
                            text={
                                code
                                    ? i18n.feature.coupon.button.TEXT
                                    : i18n.feature.bonplan.button.TEXT
                            }
                            type="button"
                            onClick={this.showLoginModal}
                        />
                    )}
                </div>
                <div className="duree one-sixth">
                    {i18n.page.MERCHANTCARD.VALID}
                    <br className="hidden-mobonly" />
                    <strong>{toDate(coupon.endDate, MOMENTJS_DATE_FORMAT)}</strong>
                </div>
            </div>
        );
    }
}
CouponComponent.propTypes = {
    coupon: PropTypes.object.isRequired,
    i18n: PropTypes.object.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    partnerId: PropTypes.string.isRequired,
    partnerName: PropTypes.string.isRequired,
    onClick: PropTypes.func
};

const mapDispatchToProps = {
    showModal
};

const mapStateToProps = state => {
    return {
        i18nCoupon: state.i18n.page.MERCHANTCARD.COUPON_TITLE
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CouponComponent);



// WEBPACK FOOTER //
// ./src/components/coupon/CouponComponent.js